<template>
  <div class="gl-w-full gl-display-flex gl-flex-direction-column mb-4">
    <gl-breadcrumb :items="breadcrumbItems" class="mt-2">
      <template #avatar>
        <img
          alt=""
          class="gl-breadcrumb-avatar-tile"
          src="@/assets/logos/breadcrumb-logo.svg"
          width="16"
          height="16"
        />
      </template>
    </gl-breadcrumb>
    <div class="container-fluid p-0 mt-4">
      <h5 class="mb-0 font-weight-bold mb-2">Wallet information</h5>

      <div class="border-bottom gl-w-full"></div>

      <div class="row mt-4" v-if="walletDetails.pendingWithdrawalTransactionId">
        <div class="col-md-8">
          <gl-card class="gl-bg-blue-100 border-0">
            <div class="d-flex flex-row">
              <div>
                <img src="@/assets/info-icon.svg" alt="" />
              </div>
              <div class="ml-3">
                <span class="gl-text-gray-500 f-14">
                  There is a pending withdrawal on this wallet.
                </span>

                <div>
                  <gl-button
                    category="primary"
                    variant="default"
                    class="mt-2"
                    size="medium"
                    @click="
                      $router.push({
                        name: 'ReviewWithdrawal',
                        params: {
                          id: walletDetails?.pendingWithdrawalTransactionId,
                        },
                      })
                    "
                  >
                    Review Transaction
                  </gl-button>
                </div>
              </div>
            </div>
          </gl-card>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4 mb-md-0 mb-3">
          <gl-card class="gl-bg-blue-100 border-0">
            <div class="gl-display-flex gl-flex-direction-column p-2">
              <span class="gl-text-gray-500 f-14">Available balance</span>
              <span class="gl-font-size-h1 gl-font-weight-bold mt-2">
                {{ walletDetails?.currency | formatCurrency }}
                {{ walletDetails?.availableBalance | formatNumber }}</span
              >
            </div>
          </gl-card>
        </div>
        <div class="col-md-4 mb-md-0 mb-3">
          <gl-card class="gl-bg-blue-100 border-0">
            <div class="gl-display-flex gl-flex-direction-column p-2">
              <span class="gl-text-gray-500 f-14"> Ledger balance </span>
              <span class="gl-font-size-h1 gl-font-weight-bold mt-2">
                {{ walletDetails?.currency | formatCurrency }}
                {{ walletDetails?.walletBalance | formatNumber }}
              </span>
            </div>
          </gl-card>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <span class="gl-text-gray-500">Name</span>
          <p class="mt-2">{{ walletDetails.businessName }}</p>
        </div>
        <div class="col-md-4">
          <span class="gl-text-gray-500">Reference</span>
          <p class="mt-2">{{ walletDetails.walletReference }}</p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4">
          <span class="gl-text-gray-500">Currency</span>
          <p class="mt-2">{{ walletDetails.currency }}</p>
        </div>
      </div>

      <!--commenting this out for now, the backend is not functional yet so all debit should use the add debit transaction feature.-->
      <!--      <gl-button-->
      <!--        buttonTextClasses="gl-display-flex gl-align-items-center"-->
      <!--        category="primary"-->
      <!--        variant="default"-->
      <!--        size="medium"-->
      <!--        class="my-3"-->
      <!--        :disabled="!!walletDetails.pendingWithdrawalTransactionId"-->
      <!--        @click="-->
      <!--          $router.push({-->
      <!--            name: 'AddDebitTransaction',-->
      <!--            params: { id: $route.params.companyId, walletId: $route.params.walletId }-->
      <!--          })-->
      <!--        "-->
      <!--      >-->
      <!--        Initiate withdrawal-->
      <!--      </gl-button>-->

      <!-- virtual account details -->
      <!--      <h5 class="mb-0 font-weight-bold mb-2 mt-4">Virtual account(s)</h5>-->
      <!--      <div class="border-bottom gl-w-full"></div>-->

      <!--      <div-->
      <!--        class="virtual-account"-->
      <!--        v-for="(account, index) in walletDetails?.virtualAccounts"-->
      <!--        :key="index"-->
      <!--      >-->
      <!--        <div class="row mt-4">-->
      <!--          <div class="col-md-4">-->
      <!--            <span class="gl-text-gray-500">Account name</span>-->
      <!--            <p class="mt-2">-->
      <!--              {{ account.accountName }} {{ account.isDefault && '(Default)' }}-->
      <!--            </p>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div class="row mt-2">-->
      <!--          <div class="col-md-4">-->
      <!--            <span class="gl-text-gray-500">Account number</span>-->
      <!--            <p class="mt-2">{{ account.accountNumber }}</p>-->
      <!--          </div>-->

      <!--          <div class="col-md-4">-->
      <!--            <span class="gl-text-gray-500">Bank</span>-->
      <!--            <p class="mt-2">{{ account.bankName }}</p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <h5 class="mb-0 font-weight-bold mb-2 mt-4">Active payout(withdrawal) account</h5>
      <div class="border-bottom gl-w-full"></div>

      <div class="row mt-4">
        <div class="col-md-4">
          <span class="gl-text-gray-500">Account name</span>
          <p class="mt-2">{{ activePayoutAccount?.accountName ?? 'N/A' }}</p>
        </div>
        <div class="col-md-4">
          <span class="gl-text-gray-500">Account number</span>
          <p class="mt-2">{{ activePayoutAccount?.accountNumber ?? 'N/A' }}</p>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4">
          <span class="gl-text-gray-500">Bank</span>
          <p class="mt-2">{{ activePayoutAccount?.bankName ?? 'N/A' }}</p>
        </div>
      </div>

      <gl-tabs class="gl-mt-6">
        <gl-tab title="Virtual Accounts">
          <template #title>
            <div class="gl-display-flex gl-align-items-center gl-gap-3">
              <span>Virtual Accounts</span>
              <gl-badge class="gl-badge badge-pill badge-muted">
                {{ walletDetails.virtualAccounts.length }}
              </gl-badge>
            </div>
          </template>

          <div class="gl-display-flex gl-align-items-center mb-3 gl-justify-content-end">
            <gl-dropdown
              text="Generate virtual account"
              split=""
              category="primary"
              variant="confirm"
              size="medium"
              :block="false"
              :disabled="false"
              class="ml-3"
            >
              <gl-dropdown-item
                v-for="provider in virtualAccountProviders"
                :key="provider.code"
                @click="generateNewVirtualAccount(provider.code)"
              >
                {{ provider.label }}
              </gl-dropdown-item>
            </gl-dropdown>
          </div>

          <gl-table
            :items="walletDetails.virtualAccounts"
            :fields="[
              { key: 'id', label: 'Id' },
              { key: 'bankName', label: 'Bank Name' },
              { key: 'accountNumber', label: 'Account Number' },
              { key: 'provider', label: 'Provider' },
              { key: 'createdAt', label: 'Created Date' },
            ]"
            fixed
            :stacked="false"
            :foot-clone="false"
            hover=""
            selectable=""
            selected-variant="primary"
            :caption="walletDetails?.virtualAccounts.length + ' virtual account(s)'"
            :show-empty="true"
          >
            <template #cell(createdAt)="data">
              <span v-if="data.value" class="text-capitalize">
                {{ data.value | humanReadableDate }}
              </span>
              <span v-else> -- </span>
            </template>
            <template #cell(bankName)="data">
              <span v-if="data.value" class="text-capitalize">
                {{ data.value }}
                <gl-badge
                  v-if="data.item.isDefault"
                  size="md"
                  class="font-weight-normal ml-2"
                  variant="success"
                  >Default
                </gl-badge>
              </span>
              <span v-else> -- </span>
            </template>
          </gl-table>
        </gl-tab>

        <gl-tab title="Wallet Transactions">
          <template #title>
            <div class="gl-display-flex gl-align-items-center gl-gap-3">
              <span>Wallet Transactions</span>
              <gl-badge class="gl-badge badge-pill badge-muted">
                {{ walletTransactions.length }}
              </gl-badge>
            </div>
          </template>
          <wallet-transaction-history
            :walletId="walletDetails?.walletId"
            :currency="walletDetails?.currency"
            :walletTransactions="walletTransactions"
            @search-transactions="searchWalletTransactions"
            @generate-statement="generateWalletStatement"
          />
        </gl-tab>

        <gl-tab title="Payout Accounts">
          <template #title>
            <div class="gl-display-flex gl-align-items-center gl-gap-3">
              <span>Payout (Withdrawal) Accounts</span>
              <gl-badge class="gl-badge badge-pill badge-muted">
                {{ payoutAccounts.length }}
              </gl-badge>
            </div>
          </template>
          <payout-accounts-tab
            :payout-accounts="payoutAccounts"
            :user-id="walletDetails.userId"
            :wallet-id="walletDetails.walletId"
            @refresh="retrievePayoutAccounts"
          />
        </gl-tab>
      </gl-tabs>
    </div>
  </div>
</template>

<script>
import WalletTransactionHistory from './WalletTransactionHistory.vue';
import PayoutAccountsTab from './PayoutAccountsTab.vue';

import {
  GlAvatar,
  GlBadge,
  GlBreadcrumb,
  GlButton,
  GlCard,
  GlDropdown,
  GlDropdownItem,
  GlTab,
  GlTable,
  GlTabs,
} from '@gitlab/ui';

export default {
  name: 'CompanyWalletDetails',
  components: {
    GlBadge,
    GlTab,
    GlTabs,
    GlDropdown,
    GlDropdownItem,
    GlTable,
    GlAvatar,
    GlBreadcrumb,
    WalletTransactionHistory,
    PayoutAccountsTab,
    GlCard,
    GlButton,
  },
  computed: {
    breadcrumbItems() {
      return [
        { text: 'Companies', href: '#' },
        {
          text: 'All companies',
          href: `/all-companies`,
        },
        {
          text: `${this.walletDetails.businessProfileId}`,
          href: `/all-companies/${this.$route.params.companyId}`,
        },
        {
          text: `${this.walletDetails.currency} Wallet`,
          href: `/all-companies/${this.$route.params.companyId}/wallets/${this.$route.params.walletId}`,
        },
      ];
    },
  },
  data: () => ({
    walletDetails: {
      businessProfileId: null,
      businessName: null,
      walletId: null,
      currency: null,
      walletReference: null,
      walletBalance: null,
      pendingWithdrawalTransactionId: null,
      outstandingLoanAmount: null,
      availableBalance: null,
      virtualAccounts: [],
    },
    filter: [],
    walletTransactions: [],
    payoutAccounts: [],
    activePayoutAccount: {
      bankName: null,
      accountName: null,
      accountNumber: null,
    },
    virtualAccountProviders: [
      {
        label: 'Wema Bank',
        code: 'Wema',
      },
      {
        label: 'Flutterwave',
        code: 'Flutterwave'
      },
      {
        label: 'Keystone Bank',
        code: 'Keystone'
      },
      {
        label: 'Access Bank',
        code: 'Access'
      },
    ],
  }),
  methods: {
    toggleLoading(isLoading) {
      this.$store.dispatch('loading/toggleLoading', isLoading);
    },

    async retrieveWalletDetails() {
      this.toggleLoading(true);
      const response = await this.$store.dispatch(
        'companies/getCompanyWallet',
        this.$route.params.companyId
      );

      const found = response.find(
        (w) => w.walletId.toString() === this.$route.params.walletId
      );
      if (found) {
        this.walletDetails = found;
        await this.retrieveWalletTransactions(this.walletDetails.walletId);
        await this.retrievePayoutAccounts();
      }

      this.$store.commit('wallet/SET_COMPANY_WALLET', this.walletDetails);

      this.toggleLoading(false);
    },
    async retrieveWalletTransactions(walletId, searchQuery = '') {
      this.toggleLoading(true);
      const response = await this.$store.dispatch('wallet/getWalletHistory', {
        walletId: walletId,
        query: { search: searchQuery },
      });
      this.walletTransactions = response || [];
      this.toggleLoading(false);
    },

    searchWalletTransactions(searchQuery) {
      this.retrieveWalletTransactions(this.walletDetails.walletId, searchQuery);
    },

    async generateWalletStatement(payload) {
      this.toggleLoading(true);
      await this.$store.dispatch('wallet/exportWalletTransactions', {
        walletId: this.walletDetails.walletId,
        ...payload,
      });
      this.toggleLoading(false);
    },

    async generateNewVirtualAccount(provider) {
      this.toggleLoading(true);
      const response = await this.$store.dispatch('wallet/createNewVirtualAccountOnWallet', {
        walletId: this.walletDetails.walletId,
        currency: this.walletDetails.currency,
        provider,
        businessId: this.walletDetails.businessProfileId,
      });
      this.walletTransactions = response || [];
      await this.retrieveWalletDetails();
      this.toggleLoading(false);
    },

    async retrievePayoutAccounts() {
      const response = await this.$store.dispatch('wallet/getTransferRecipients', {
        userId: this.walletDetails.userId,
        walletId: this.walletDetails.walletId,
      });
      this.payoutAccounts = response || [];
      this.activePayoutAccount = this.payoutAccounts.find(account => account.isActive);
    },
  },
  beforeMount() {
    this.retrieveWalletDetails();
  },
};
</script>

<style></style>
